import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import type { ProjectTypeId } from '../model/types';
import { projectTypeChanged, type Action } from '../state/actions';
import type { State } from '../state/types';
import { getAriaLabel, getProjectTypes } from './selectors';
import ProjectType from './view';

const mapStateToProps = (state: State) => ({
	projectTypes: getProjectTypes(state),
	ariaLabelText: getAriaLabel(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
	// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
	onChange: (projectTypeIds: ProjectTypeId[], analyticsEvent) => {
		dispatch(projectTypeChanged(projectTypeIds, analyticsEvent));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectType);
